import axios from "axios";
import { getJWT, removeUSER, baseUrl } from "./constant";
import router from "../router/index";
import { MessageBox, Message } from "element-ui";

export function instance(url) {
  // let time = new Date().getTime();

  // let method = baseUrl + url;

  let instance = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${getJWT()}`,
      // method: method,
    },
  });

  /**
   * 添加请求拦截器
   */
  instance.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(erro);
    }
  );

  /**
   * 添加响应拦截器
   */
  instance.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (erro) => {
      return Promise.reject(erro);
    }
  );

  return instance;
}

export function getRequest(params) {
  if (!params || !params.url) {
    return;
  }
  return new Promise((resolve, reject) => {
    let obj = {
      params: params.data || {},
    };
    if (params.type) {
      obj.responseType = "blob";
    }
    instance(params.url)
      .get(params.url, obj)
      .then((res) => {
        if (res.errcode == 200) {
          resolve(res);
        } else if (res.errcode == 400) {
          userLoginOut();
        } else {
          Message({
            message: res.errmsg,
            type: "error",
            duration: 5 * 1000,
          });
        }
      })
      .catch((erro) => {
        reject(erro);
      });
  });
}

export function postRequest(params) {
  if (!params || !params.url) {
    return;
  }
  return new Promise((resolve, reject) => {
    instance(params.url)
      .post(params.url, params.data, {
        // headers: {
        //   "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        // },
      })
      .then((res) => {
        if (res.errcode == 200) {
          resolve(res);
        } else if (res.errcode == 400) {
          userLoginOut();
        } else {
          Message({
            message: res.errmsg,
            type: "error",
            duration: 5 * 1000,
          });
        }
      })
      .catch((erro) => {
        reject(erro);
      });
  });
}

export function deleteRequest(params) {
  if (isEmpty(params) || isEmpty(params.url)) {
    return;
  }
  return new Promise((resolve, reject) => {
    instance(params.url)
      .delete(params.url + `?${params.data}`)
      .then((res) => {
        if (res.errcode == 200) {
          resolve(res);
        } else if (res.errcode == 400) {
          userLoginOut();
        } else {
          Message({
            message: res.errmsg,
            type: "error",
            duration: 5 * 1000,
          });
        }
      })
      .catch((erro) => {
        reject(erro);
      });
  });
}

export function userLoginOut() {
  console.log("登录信息过期");
  removeUSER();
  router.replace("/");
}
